<template>
  <div class="relative">
    <van-popup v-model="toggleStatus" round position="bottom">
      <van-picker
        title="Status"
        confirm-button-text="Pilih"
        cancel-button-text="Batal"
        show-toolbar
        :columns="data.conditionSelection"
        @cancel="toggleStatus = false"
        @confirm="
          (e) => {
            cleaningStatus = e;
            toggleStatus = false;
          }
        "
      />
    </van-popup>
    <van-popup v-model="toggle" round position="left" class="w-full h-full pb-12">
      <!-- Show the timer -->
      <!-- contain before and after camera input -->
      <div class="p-2 flex gap-2 justify-between items-center bg-primary sticky top-0 z-50">
        <div class="text-right px-4 py-2 rounded-xl text-white">
          <p class="">Timer</p>
          <p class="text-3xl font-bold">{{ timerDisplay }}</p>
        </div>
        <div class="text-white">
          <button class="px-4 py-2 rounded-full text-sm" @click="cancelTask">
            <v-icon icon="ph:stop-fill" class="text-3xl mx-auto" />
            <p>Cancel</p>
          </button>
          <button class="px-4 py-2 rounded-full text-sm" @click="finishTask">
            <v-icon icon="ph:check-bold" class="text-3xl mx-auto" />
            <p>Finish</p>
          </button>
        </div>
      </div>
      <div class="bg-slate-100 h-full">
        <PictureForm title="Ambil Foto Sebelum" :picture="picture.before" @selected="(a) => (picture.before = a)" />
        <PictureForm title="Ambil Foto Setelah" :picture="picture.after" @selected="(a) => (picture.after = a)" />

        <van-cell-group inset title="Keadaan ">
          <van-field
            readonly
            clickable
            label="Keadaan"
            :value="cleaningStatus"
            placeholder="Pilih Status"
            @click="() => (toggleStatus = true)"
          />
          <!-- <van-cell -->
        </van-cell-group>
        <div class="p-4 text-sm opacity-75 italic text-red-800">
          * Tolong untuk tetap membuka aplikasi selama proses pembersihan
        </div>
      </div>
    </van-popup>

    <van-cell-group inset :title="data.name || 'Checklist Item'">
      <van-cell
        :title="data.name || 'Kamar Mandi'"
        @click="startTimer"
        v-if="!verdict"
        :label="verdict ? 'Sudah di isi' : 'Tekan untuk memulai'"
      >
        <template #right-icon>
          <div class="flex items-center -mr-2">
            <div class="flex items-center bg-primary text-white rounded">
              <v-icon icon="ph:play-fill" class="text-xl my-auto ml-2" />
              <span class="rounded-full px-3 py-2 text-sm"> Mulai</span>
            </div>
          </div>
        </template>
      </van-cell>
      <van-cell v-else :title="`Hasil ${cleaningStatus}`" :label="verdict">
        <template #icon>
          <v-icon icon="ph:check-circle" class="text-2xl my-auto ml-2 mr-4 text-success" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import PictureForm from "./PictureForm.vue";
  export default {
    components: {
      PictureForm
    },
    props: {
      title: String,
      data: Object,
      groupTitle: String
    },
    data() {
      return {
        toggle: false,
        toggleStatus: false,
        cleaningStatus: null,
        intervalTimer: null,
        timerDisplay: "00:00",
        verdict: null,
        picture: {
          before: null,
          after: null
        }
      };
    },
    mounted() {},
    emits: ["selected"],
    watch: {
      picture: {
        handler(val) {
          this.$emit("selected", val);
        },
        immediate: true,
        deep: true
      }
    },
    computed: {
      locationData() {
        return this.pointLocations.data.find((x) => x.id === this.qr.code) || null;
      }
    },
    methods: {
      startTimer() {
        this.toggle = true;
        let time = 0;
        this.intervalTimer = setInterval(() => {
          time++;
          // Update the timer display
          this.timerDisplay = this.formatTime(time);
        }, 1000);
      },
      finishTask() {
        clearInterval(this.intervalTimer);
        this.toggle = false;
        this.verdict = "Task completed in " + this.timerDisplay;
      },
      formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
      },
      cancelTask() {
        clearInterval(this.intervalTimer);
        this.toggle = false;
      }
    }
  };
</script>
